/* =============================================================================
   Bartisans — SHELF CARD behaviour (canonical) · Thrudaruf 02/08/2026

   Ported verbatim in behaviour from the inline <script> that used to live in
   sections/bartisans-bestsellers.liquid (the reference implementation):
     - serve-size pills built from data-variants
     - price + per-drink line kept in sync with the selected variant
     - single-variant cards hide the selector and inherit its bottom margin
     - ATC posts to /cart/add.js, flashes "Added ✓" for 2.2s, pushes dataLayer
     - header cart count refreshed from /cart.js + cart:refresh event

   Two Liquid-time values became data attributes so this can live in an asset:
     data-perdrink="true|false"  was  {% if section.settings.show_per_drink %}
     --btc-serve-mb (CSS var)    was  the hardcoded 13px / 14px marginBottom

   Cards are initialised on load AND via MutationObserver, because the two PDP
   rows (product-recommendations / recently-viewed-products) inject their cards
   asynchronously through the Section Rendering API.

   26/08/2026 — COVER IMAGE IS PER-VARIANT. snippets/bartisans-shelf-card.liquid
   now writes "cut" / "cutset" / "flat" into each entry of data-variants, already
   resolved through the four-rung fallback chain documented at the top of that
   snippet (variant cutout > product cutout > whitebg > featured image). select()
   is the ONE place the card reacts to a serve-size click, so the cover swap is
   hooked in there next to the price — do not add a second listener on the pills.
   Cards whose variants carry no cutout of their own receive the product-level
   value in every entry, so the toggle is a no-op for them and the image simply
   stays put. That is the intended no-regression behaviour, not a broken swap.

   10/09/2026 — PER-DRINK IS BRACKETED, NOT MIDDOT-PREFIXED: "(₹178 a drink)".
   sections/bartisans-shop-grid.liquid was changed to brackets on 09/09 but this
   file was missed, so the collection grid and the homepage / PDP shelf rows
   disagreed on the same line. Both JS branches below write it — the multi-
   variant select() and the single-variant fallback — and BOTH must match, as
   must the server-rendered initial value in snippets/bartisans-shelf-card.liquid.

   03/09/2026 — THE SINGLE-VARIANT BRANCH NO LONGER HIDES A NON-EMPTY WRAPPER.
   The bullet above ("single-variant cards hide the selector and inherit its
   bottom margin") is now CONDITIONAL. snippets/bartisans-shelf-card.liquid
   server-renders a static serve chip for a single-variant product whose title
   yields a drinks count, and hiding it unconditionally was exactly the blank
   gap Krit reported on "Golden Hour (2 Drinks)". Both the hide and the margin
   compensation are now guarded on serveWrap.children.length being 0, so the
   wrapper only collapses when it is genuinely empty (the gift boxes). See the
   dated comment on that branch below.
   sections/bartisans-shop-grid.liquid draws its own card, never loads this
   file, and carries the identical fix in parallel — change the two together.
   ============================================================================= */
(function () {
  if (window.__btShelfCardLoaded) return;
  window.__btShelfCardLoaded = true;

  function drinksOf(title) { var m = (title || '').match(/(\d+)\s*Drink/i); return m ? parseInt(m[1], 10) : null; }
  function packDrinks(title) { var m = (title || '').match(/Makes\s*(\d+)\s*Drinks/i); return m ? parseInt(m[1], 10) : null; }
  function inr(cents) { return '₹' + Math.round(cents / 100).toLocaleString('en-IN'); }

  function bumpCartUi() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('.header__cart-count').forEach(function (el) { el.textContent = c.item_count; });
    }).catch(function () {});
    try { document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch (e) {}
  }

  function initCard(card) {
    if (card.__btCardReady) return;
    card.__btCardReady = true;

    var variants;
    try { variants = JSON.parse(card.getAttribute('data-variants')); } catch (e) { return; }
    if (!variants) return;

    var showPerDrink = card.getAttribute('data-perdrink') !== 'false';
    var serveWrap = card.querySelector('[data-bt-serve]');
    var priceEl = card.querySelector('[data-bt-price]');
    var pdEl = card.querySelector('[data-bt-perdrink]');
    var atc = card.querySelector('[data-bt-atc]');
    var nameEl = card.querySelector('.bt-card__name');
    var cutEl = card.querySelector('.bt-card__cut');
    if (!serveWrap || !priceEl || !pdEl || !atc) return;
    var selected = null;

    /* Cover layer for the selected variant. The Liquid already server-rendered
       the first variant's cutout, so the identical-src guard makes the initial
       select() a no-op instead of a second network request. */
    function applyCut(v) {
      if (!cutEl || !v || !v.cut) return;
      if (cutEl.getAttribute('src') === v.cut) return;
      if (v.cutset) { cutEl.setAttribute('srcset', v.cutset); } else { cutEl.removeAttribute('srcset'); }
      cutEl.setAttribute('src', v.cut);
      cutEl.classList.toggle('bt-card-img--flat', !!v.flat);
    }

    function select(v) {
      selected = v;
      priceEl.textContent = inr(v.price);
      applyCut(v);
      var d = drinksOf(v.title);
      if (showPerDrink && d) { pdEl.textContent = '(' + inr(Math.round(v.price / d)) + ' a drink)'; }
      serveWrap.querySelectorAll('button').forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-vid') == String(v.id) ? 'true' : 'false');
      });
      atc.disabled = !v.available;
      if (!v.available) atc.textContent = 'Sold Out';
    }

    if (variants.length > 1) {
      /* 26/08/2026 — the PILLS are ordered smallest pack first, independently of
         variant position. Shopify's variant order now puts 4 Drinks at position 1
         so the PDP opens on it, but on a card the selected pill is 2 Drinks and
         a toggle that reads "4 Drinks | 2 Drinks" with the RIGHT one lit looks
         like a bug. Sorting here, not reordering the data, keeps data-variants a
         faithful copy of Shopify's order for everything else that reads it. */
      variants.slice().sort(function (a, b) { return (drinksOf(a.title) || 99) - (drinksOf(b.title) || 99); }).forEach(function (v) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'bt-card__pill';
        b.setAttribute('data-vid', v.id);
        b.setAttribute('aria-pressed', 'false');
        b.textContent = v.title;
        if (!v.available) b.disabled = true;
        b.addEventListener('click', function () { select(v); });
        serveWrap.appendChild(b);
      });
      /* 26/08/2026 — cards open on the 2-serve pack even though 4 Drinks is now
         variant position 1 (see the dated block in snippets/bartisans-shelf-card.liquid).
         Must stay in step with the Liquid there, or the card repaints on load. */
      var first = variants.find(function (v) { return v.available && /2\s*Drink/i.test(v.title); })
              || variants.find(function (v) { return v.available; })
              || variants[0];
      select(first);
    } else {
      /* 03/09/2026 — HIDE ONLY WHEN THE WRAPPER IS GENUINELY EMPTY. The Liquid
         server-renders a static .bt-card__pill--static chip into the serve
         wrapper for a single-variant product whose title yields a drinks count;
         this branch used to hide the wrapper unconditionally and the inline
         display:none beats the ':empty' rule in bartisans-shelf-card.css
         wherever the @supports (subgrid) block carrying it does not apply, so
         the chip the Liquid had just drawn was hidden again.
         The margin compensation is guarded on the SAME condition on purpose: it
         stands in for the wrapper's own margin-bottom, so it is only owed when
         the wrapper actually leaves the flow. Multi-variant cards unchanged. */
      if (!serveWrap.children.length) {
        serveWrap.style.display = 'none';
        var pl = card.querySelector('.bt-card__priceline');
        if (pl) {
          /* the hidden selector took its own margin-bottom out of the flow — the
             price line inherits it so the ATC baseline does not shift. */
          var mb = (getComputedStyle(card).getPropertyValue('--btc-serve-mb') || '').trim();
          pl.style.marginBottom = mb || '13px';
        }
      }
      selected = variants[0];
      if (selected) {
        priceEl.textContent = inr(selected.price);
        applyCut(selected);
        if (showPerDrink) {
          var d0 = drinksOf(selected.title) || packDrinks(nameEl ? nameEl.textContent : '') || (/2-?drinks|2-?serve/.test(card.getAttribute('data-handle') || '') ? 2 : null);
          if (d0) pdEl.textContent = '(' + inr(Math.round(selected.price / d0)) + ' a drink)';
        }
        if (!selected.available) { atc.disabled = true; atc.textContent = 'Sold Out'; }
      }
    }

    atc.addEventListener('click', function () {
      if (!selected) return;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: selected.id, quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('atc');
        var old = atc.textContent;
        atc.classList.add('is-added');
        atc.textContent = 'Added ✓';
        setTimeout(function () { atc.classList.remove('is-added'); atc.textContent = old; }, 2200);
        try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'add_to_cart', ecommerce: { currency: 'INR', value: selected.price / 100, items: [{ item_name: (nameEl ? nameEl.textContent.trim() : '') + ' — ' + selected.title, quantity: 1 }] } }); } catch (e) {}
        bumpCartUi();
      }).catch(function () { atc.textContent = 'Try again'; });
    });
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-bt-card]').forEach(initCard);
    if (root && root.matches && root.matches('[data-bt-card]')) initCard(root);
  }

  window.BartisansShelfCard = { init: initAll, initCard: initCard };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  /* PDP rows inject their markup after a fetch — catch them as they land. */
  try {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (n.matches && n.matches('[data-bt-card]')) initCard(n);
          else if (n.querySelectorAll) n.querySelectorAll('[data-bt-card]').forEach(initCard);
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target || document); });
})();